/* dealshub-recently-capture.js — site-wide PDP visit capture for Recently Viewed.
 *
 * Writes a snapshot of the product the user is currently viewing into
 * localStorage 'dh_recent_v2'. Two PDP shapes are supported:
 *   1) /products/HANDLE                       — Shopify-native PDP (synced products)
 *   2) /pages/product?source=X&id=Y           — DealsHub live PDP (catalog browse)
 * Snapshot shape matches the DealsHub API product contract so
 * StyleHub.buildProductCard can render it directly.
 */
(function(){
  if (typeof localStorage === 'undefined') return;
  var KEY = 'dh_recent_v2', MAX = 24;

  function load() {
    try { var raw = localStorage.getItem(KEY); var arr = raw ? JSON.parse(raw) : []; return Array.isArray(arr) ? arr : []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function dedupePush(list, item) {
    if (!item || !item.url) return list;
    var key = item.url;
    list = list.filter(function(it){ return it && it.url && it.url !== key; });
    list.unshift(item);
    return list;
  }

  function captureFromShopifyPDP() {
    // Read from window.ShopifyAnalytics or product JSON if present, else from /products/{handle}.js
    var m = location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    fetch('/products/' + handle + '.js', { credentials:'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]);
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var snap = {
          id: p.id,
          title: p.title || '',
          price: typeof p.price === 'number' ? (p.price/100) : null,
          originalPrice: (typeof p.compare_at_price === 'number' && p.compare_at_price > p.price) ? (p.compare_at_price/100) : null,
          image: img || '',
          url: '/products/' + handle,
          rating: null,
          reviews: null,
          source: 'shopify',
          sourceName: 'StyleHub',
          handle: handle,
          ts: Date.now()
        };
        save(dedupePush(load(), snap));
      })
      .catch(function(){});
  }

  function captureFromDealsHubPDP() {
    if (location.pathname !== '/pages/product') return;
    var qs = new URLSearchParams(location.search);
    var source = qs.get('source'), id = qs.get('id') || qs.get('store_id');
    if (!source || !id) return;
    // Wait for window.__DH_PRODUCT (set by /pages/product script) up to 3s
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      var p = window.__DH_PRODUCT || window.dhProduct || window.currentProduct;
      if (p && (p.title || p.image)) {
        clearInterval(iv);
        var snap = {
          id: id,
          sourceId: id,
          title: p.title || '',
          price: typeof p.price === 'number' ? p.price : (p.price ? Number(p.price) : null),
          originalPrice: p.originalPrice || null,
          image: p.image || (p.images && p.images[0]) || (p.primaryImage) || '',
          url: '/pages/product?source=' + encodeURIComponent(source) + '&id=' + encodeURIComponent(id),
          rating: p.rating || null,
          reviews: p.reviews || null,
          source: source,
          sourceName: p.sourceName || source,
          ts: Date.now()
        };
        save(dedupePush(load(), snap));
      }
      if (tries > 30) clearInterval(iv); // give up after ~3s
    }, 100);
  }

  function init(){
    try { captureFromShopifyPDP(); } catch (e) {}
    try { captureFromDealsHubPDP(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
